<p>
  {{ 'AUTH.LEAD.CREATION' | translate}}
</p>
